
document.documentElement.classList.add('js');

document.addEventListener('click',function(e){
  var t=e.target.closest('[data-menu-toggle]');
  if(t){document.querySelector('.site-nav').classList.toggle('open');}
});
// scroll reveal for homepage sections
(function(){
  var els = document.querySelectorAll('[data-reveal]');
  if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(el){el.classList.add('in');}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
  els.forEach(function(el){ io.observe(el); });
})();
// floating back-to-top button (appears after scrolling down)
(function(){
  var btn = document.createElement('button');
  btn.id = 'scroll-top';
  btn.className = 'sans';
  btn.setAttribute('aria-label', 'Nach oben');
  btn.innerHTML = '&#8593;';
  btn.addEventListener('click', function(){ window.scrollTo({top: 0, behavior: 'smooth'}); });
  document.body.appendChild(btn);
  var ticking = false;
  function update(){ btn.classList.toggle('on', window.scrollY > 400); ticking = false; }
  window.addEventListener('scroll', function(){
    if(!ticking){ requestAnimationFrame(update); ticking = true; }
  }, {passive: true});
  update();
})();
// cart page: auto-update quantities (Aktualisieren button is the no-JS fallback)
document.querySelectorAll('.cart-qty').forEach(function(inp){
  inp.addEventListener('change', function(){ if(inp.form){ inp.form.submit(); } });
});
// add to cart without leaving the page
document.addEventListener('submit', function(e){
  var f = e.target;
  var action = f.getAttribute('action') || '';
  if(action.indexOf('/cart/add') === -1) return;
  if(!window.fetch || !window.FormData) return;
  e.preventDefault();
  var btn = f.querySelector('[type="submit"]');
  if(btn && !btn.dataset.label){ btn.dataset.label = btn.textContent; }
  fetch('/cart/add.js', {method:'POST', body:new FormData(f), headers:{'Accept':'application/json'}})
    .then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); })
    .then(function(){ return fetch('/cart.js'); })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      document.querySelectorAll('.cart-link').forEach(function(l){
        l.textContent = l.textContent.replace(/\d+\s*$/, cart.item_count);
      });
      var fab = document.getElementById('cart-fab');
      if(fab){
        var c = fab.querySelector('.count');
        if(c){ c.textContent = cart.item_count; }
        fab.classList.add('on');
        fab.classList.remove('pulse');
        void fab.offsetWidth;
        fab.classList.add('pulse');
      }
      if(btn){
        btn.textContent = '✓';
        btn.classList.remove('added');
        void btn.offsetWidth;
        btn.classList.add('added');
        setTimeout(function(){
          btn.textContent = btn.dataset.label;
          btn.classList.remove('added');
        }, 1500);
      }
    })
    .catch(function(){ f.submit(); });
});
